import { OrderInvoiceStatus } from "../../../models/ordering/enums/order-invoice-status";
import { OrderShipmentStatus } from "../../../models/ordering/enums/order-shipment-status";
import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";
import { ShipmentMethod } from "../enums/shipment-method";

export class FedexSearchFilter implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_ORDERS_QUERY;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Order ID', ''),
            new ListColumn('Dealer', ''),
            new ListColumn('Quantity', ''),
            new ListColumn('Description', ''),
            new ListColumn('Job Name', ''),
            new ListColumn('Amount', ''),            
        ];

        const readonlyLabl = this.buildReadonlyLabel();
        this.filters.push(readonlyLabl);

        // Create our Non-Optional Filters
        const byShipmentMethod = this.buildShipmentMethod();
        const byShipmentStatus = this.buildShipmentStatus();
        const byInvoiceStatus = this.buildInvoiceStatus();
        
        this.requiredFilters.push(byShipmentMethod);
        this.requiredFilters.push(byShipmentStatus);
        this.requiredFilters.push(byInvoiceStatus);
        
    }

    private buildReadonlyLabel() {
        const byAssetName = new FilterGroup('Name', 'readonly', 'name');
        const opt1 = new FilterBarInputOpt('Fedex Orders', '');
        
        byAssetName.opts = [opt1];

        return byAssetName;
    }

    private buildShipmentMethod() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'Shipment Method';
        requiredType.qsName     = 'shippingMethod';
        requiredType.qsValue    = `${ ShipmentMethod.Fedex }`;

        return requiredType;
    }

    private buildShipmentStatus() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'Shipment Status';
        requiredType.qsName     = 'shipmentStatus';
        requiredType.qsValue    = `${ OrderShipmentStatus.Pending },${ OrderShipmentStatus.Open },${ OrderShipmentStatus.Completed }`;

        return requiredType;
    }

    private buildInvoiceStatus() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'Invoice Status';
        requiredType.qsName     = 'invoiceStatus';
        requiredType.qsValue    = `${ OrderInvoiceStatus.NotApplicable },${ OrderInvoiceStatus.Pending },${ OrderInvoiceStatus.Open }`;

        return requiredType;
    }

}
